// Normalize any book type string to database format (SHORT_STORY, NOVELLA, NOVEL)
export function normalizeBookType(workType: string): string {
    if (!workType) return 'NOVEL';
    
    const normalized = workType.toUpperCase().replace(/\s+/g, '_');
    
    // Direct matches
    if (['SHORT_STORY', 'NOVELLA', 'NOVEL'].includes(normalized)) {
        return normalized;
    }
    
    // Handle common variations
    if (normalized === 'SHORT_STORY' || normalized === 'SHORT STORY') return 'SHORT_STORY';
    if (normalized === 'ARTICLE' || normalized === 'LINKEDIN_POST' || normalized === 'BLOG_POST' || 
        normalized === 'RESEARCH_PAPER' || normalized === 'OTHER') {
        return 'NOVEL'; // Default fallback for non-fiction types
    }
    
    return 'NOVEL'; // Default fallback
}

// Convert database bookType to readable format for UI
export function bookTypeToDisplayName(bookType: string): string {
    if (!bookType) return 'Novel';
    
    switch (bookType.toUpperCase()) {
        case 'SHORT_STORY':
            return 'Short Story';
        case 'NOVELLA':
            return 'Novella';
        case 'NOVEL':
            return 'Novel';
        default:
            return 'Novel';
    }
}

// Convert database bookType to word count targets
export function getDefaultWordCountForBookType(bookType: string): number {
    switch (bookType?.toUpperCase()) {
        case 'SHORT_STORY':
            return 5000;
        case 'NOVELLA':
            return 30000;
        case 'NOVEL':
        default:
            return 80000;
    }
}

// Legacy function for backwards compatibility
export function deriveLiteraryFormFromBookType(bookType: string): string {
    return bookTypeToDisplayName(bookType);
}

// Convert old literaryForm to new bookType
export function literaryFormToBookType(literaryForm: string): string {
    if (!literaryForm) return 'NOVEL';
    
    const normalized = literaryForm.toLowerCase().trim();
    switch (normalized) {
        case 'short story':
            return 'SHORT_STORY';
        case 'novella':
            return 'NOVELLA';
        case 'novel':
        default:
            return 'NOVEL';
    }
}